

document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM loaded');
}, false);

